import { useLocation } from 'react-router-dom';
import { getPartOfCurrentQueryString } from 'helpers/getPartOfCurrentQueryString';
import { combineQueryStrings } from 'helpers/combineQueryStrings';
import { QueryParams, RoutePaths } from 'types/enums';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';

type BrowseLinkProps = { showFreeOnly: boolean };

export const useBrowseLink = (options?: BrowseLinkProps): string => {
    const { search } = useLocation();
    const toLocalizedPath = useToLocalizedPath();

    const currentQueryString = getPartOfCurrentQueryString({
        routerQueryString: search,
        queriesToExclude: [
            QueryParams.search,
            QueryParams.type,
            QueryParams.page,
        ],
    });

    const newFilterQuery = combineQueryStrings(
        currentQueryString,
        options?.showFreeOnly ? `textSearch=Free&Type=loop` : `Type=loop`,
    );

    return toLocalizedPath(`/${RoutePaths.Browse}?${newFilterQuery}`);
};
